<template>
  <v-app class="whole">
    <div class="inside">
    <div class="myform">
      <div class="title-spaced">
        <v-layout wrap>
          <v-flex xs6 sm6 md6 text-left>
            <h2 class="text-left ">お買い物情報</h2>
          </v-flex>
          <v-flex xs6 sm6 md6 text-right>
            <!-- <v-chip class="white--text ml-0" color="indigo" label outlined small>個人のお客様</v-chip> -->
          </v-flex>
        </v-layout>
        <!-- <v-divider></v-divider> -->
        <!-- <small class="text-left ">商品のご購入の際にはお客様情報のご入力が必要です。<br> -->
          <!-- </small> -->
      </div>
      <div class="infoSpace">
        <div class="titleCompany">お買い物情報</div>
        <div class="tableSpace">
          <v-simple-table >
            <thead>
              <tr>
                <th class="text-center productPic"></th>
                <!-- <th class="text-left " style="width:100px"></th> -->
                <th class="text-left"  style="width:120px"></th>
                <th class="text-left" style="width:500px"></th>
                <th class="text-center"  style="width:100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dic in items" :key="dic.id" >
                <td class="text-center productPic">
                   <v-img :src="dic.pic" :width="100" class=" productPic"></v-img>
                </td>
                <!-- <td class="text-left">１点</td> -->
                <!-- <td class="text-left">{{ dic.category }}</td> -->
                <td class="text-center">{{ dic.categoryName_JP }}</td>
                <td class="text-left">{{ dic.text }}</td>
                <td class="text-left"><b>{{ dic.price | toLocaleString}}円</b></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
        <div class="tableSpace_sum">
          <v-simple-table >
            <thead>
              <tr>
                <th class="text-right"></th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
               <tr >
                <td class="text-center">送料</td>
                <td class="text-right"><b>{{ shipping | toLocaleString }}円</b></td>
              </tr>
              <tr >
                <td class="text-center">小計</td>
                <td class="text-right"><b>{{ totalPrice | toLocaleString }}円</b></td>
              </tr>
              <tr >
                <td class="text-center">税金</td>
                <td class="text-right"><b>{{ totalPrice * 0.1 | toLocaleString }}円</b></td>
              </tr>
              <tr >
                <td class="text-center">合計</td>
                <td class="text-right "><div class="totalPrice">{{ totalPrice * 1.1 | toLocaleString}}円</div></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
      <div class="infoSpace">
        <div class="titleCompany">お客様情報</div>
        <div class="tableSpace">
          <v-simple-table >
            <thead>
              <tr>
                <th class="text-left"  style="width:120px"></th>
                <th class="text-center"  style="width:100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr >
                <td class="text-center">お名前</td>
                <td class="text-left">{{ profile.name }}</td>
              </tr>
              <tr >
                <td class="text-center">住所</td>
                <td class="text-left" >
                  <div v-if="typeof profile.zipcode != 'undefined'">
                  〒{{ profile.zipcode }}</div>
                  {{ profile.address }}<br>
                  {{ profile.building }}
                </td>
              </tr>
              <tr >
                <td class="text-center">電話番号</td>
                <td class="text-left">{{ profile.phone }}</td>
              </tr>
              <tr >
                <td class="text-center">メールアドレス</td>
                <td class="text-left">{{ profile.mail }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
      <div class="infoSpace">
        <div class="titleCompany">クレジットカード情報</div>
        <div class="tableSpace">
          <v-simple-table >
            <thead>
              <tr>
                <th class="text-left"  style="width:120px"></th>
                <th class="text-center"  style="width:100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr >
                <td class="text-center">カード番号</td>
                <td class="text-left">{{ profile.credit_num }}</td>
              </tr>
              <tr >
                <td class="text-center">名義人</td>
                <td class="text-left">{{ profile.credit_name }}</td>
              </tr>
              <tr >
                <td class="text-center">有効期限</td>
                <td class="text-left">{{ profile.credit_month }}月/{{ profile.credit_year }}年</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
      <div class="btnSet2">
        <v-btn color="indigo" block dark x-large  @click="buy">
          <span class="material-icons">done</span><div class="btnText">購入する</div></v-btn>
      </div>


    </div>
    </div>
  </v-app>
</template>

<script>
import products from "./ECサイト商品リスト.json";
import { mapGetters } from "vuex"
  export default {
    data() {
      return {
        inputForm: {},      
        items: [],
        products,
        shipping: 1500,
      }
    },
    computed:{
      product() {
        const result = products.find((v) => v.id === Number(this.id))
        return result
      },
      ...mapGetters('cart', ['productsList','profile']),
      totalPrice() {
        let totalPrice = 0
        for(let item in this.productsList){
          
          let id = this.productsList[item]
          // window.console.log('id: ', id)
          const result = products.find((v) => v.id === Number(id))
          this.items.push(result)

          totalPrice += result.price
        }
        totalPrice += this.shipping
        
        return totalPrice
      },
    },
    mounted() {
     
    },
    filters: {
      toLocaleString(value) {
        return value.toLocaleString();
      },
    },
    methods: {
      buy() {
        // this.$store.dispatch('cart/updateProfile', inputForm )
        this.$router.push({ name: 'thanks' })
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 70%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .productPic {
    margin: 10% 0;
    /* padding: 10% 0; */
  }
</style>